import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class Api {
  _url:string='';
  constructor(
    private http: HttpClient
  ){ }

  request(method: any, endpoint: any, data: any, headers: any, callback:any){
    if(method=='post'){
      this.sendPost(this._url + '/' + endpoint,data,headers,callback);
    }
    if(method=='get'){
      this.sendGet(this._url + '/' + endpoint,callback);
    }
    if(method=='put'){
      this.sendPut(this._url + '/' + endpoint,data,headers,callback);
    }
    if(method=='download'){
      this.download(endpoint,{responseType:'blob'},callback);
    }
  }

  sendPost(url:any,body:any,headers:any,callback:any){
    if(!body.removerApiKey){
      body.app_key="rtEVWH9FSjx6KoUxMxuN0uC6";
      body.app_secret="4rEyQRcvb0P4";
    }else{
      delete body.removerApiKey;
    }

    this.http.post(url,body,headers).subscribe(result => callback(result),
    error => callback({status:false,error:error.message.split('url').length>1?'URL não encontrada '+url:error.message}));
  }

  sendForgot(url:any,body:any,headers:any,callback:any){
    this.http.post(url,body,headers).subscribe(result => callback(result),
    error => callback({status:false,error:error.message.split('url').length>1?'URL não encontrada '+url:error.message}));
  }

  sendPut(url:any,body:any,headers:any,callback:any){
    this.http.put(url,body,headers).subscribe(callback);
  }

  sendGet(url:any,callback:any){
    this.http.get(url).subscribe(callback);
  }

  download(url:any,headers:any,callback:any){
    this.http.get(url,headers).subscribe((result:any) => callback(result),error => callback({status:false,error:error.message.split('url').length>1?'URL não encontrada '+url:error.message}));
  }

  setHost(url:any){
    // if(url){
      this._url = url;
    // }
    return this._url;
  }

  getHost(){
    return this._url;
  }
}



// WEBPACK FOOTER //
// ./src/providers/api/api.ts